export default __webpack_public_path__ + "static/media/random-Medium.ed400a9b.png";